// extracted by mini-css-extract-plugin
module.exports = {"container":"mindmapOrientationPicker_container__6k0ph"};